import { render, staticRenderFns } from "./CompanyRiskEvents.vue?vue&type=template&id=6bd883ce&scoped=true&"
import script from "./CompanyRiskEvents.vue?vue&type=script&lang=js&"
export * from "./CompanyRiskEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd883ce",
  null
  
)

export default component.exports